export default __webpack_public_path__ + "84af3ed2fdec6ad08526b45208d8bff6.png";